import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material';
import {
  Router, Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from "@angular/router";
import { MENUS } from './interfaces/menus'
import {AuthService} from './core/auth.service';
import { MatSnackBar } from '@angular/material';

const SMALL_WIDTH_BREAKPOINT = 1100;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  public loading: boolean = true;

  menus = MENUS;

  @ViewChild('sidenav') sidenav: MatSidenav;

  constructor(public snackBar: MatSnackBar, private router: Router, public authService: AuthService) {
    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });

   }

  ngOnInit() {

    this.router.events.subscribe(() => {
      if (this.isScreenSmall()) {
        this.sidenav.close();
      }
    });

  }

 

  isScreenSmall(): boolean {
    return window.matchMedia(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`).matches;
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true;
    }
    if (event instanceof NavigationEnd) {
      // navigation delay 0 secs
      // this.loading = false;

      // navigation delay 2 secs
      setTimeout(() => this.loading = false, 1000);

    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loading = false;
    }
    if (event instanceof NavigationError) {
      this.loading = false;
    }
    
  }

  salir() {
    this.snackBar.open('Has cerrado sesión correctamente, vuelve pronto.', 'CERRAR', {
      duration: 4000
    });
    this.authService.salir();
    this.router.navigate(['/']);
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts